module.exports = __webpack_public_path__ + "static/media/apartment7.00f20e2c.png";